export const projectIds = {
  kpk: 'aff1bf53-f002-4e11-a314-0ed6115aea2d'
};
